export enum CheckboxPosition {
  Default = 'default',
  Right = 'right',
}
